import { codeToTokensBase } from "shiki"

export interface CodeHighlightToken {
  content: string
  color?: string
}

export type ShikiTheme = "github-dark" | "github-light"

export async function tokenize(
  code: string,
  theme: ShikiTheme,
): Promise<CodeHighlightToken[][]> {
  return codeToTokensBase(code, { lang: "python", theme })
}
